import { font, color, query, space } from '@design/templateFns';
import styled, { css } from 'styled-components';

export const GridContainer = styled.div<{ $reverse?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space('x8')};
  margin-top: ${space('x10')};
  margin-bottom: ${space('x10')};

  ${({ $reverse }) =>
    $reverse &&
    css`
      > div:nth-child(2) {
        order: -1;
      }
    `}

  @media screen and (${query.atLeast('desktop')}) {
    grid-template-columns: 1fr 1fr 1fr;
    align-items: start;
    gap: ${space('x8')};
  }

  @media screen and (${query.atLeast('max')}) {
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: ${space('x12')};
  }
`;

export const ContentContainer = styled.div`
  @media screen and (${query.atLeast('desktop')}) {
    grid-column: span 2;
  }

  @media screen and (${query.atLeast('max')}) {
    grid-column: span 1;
  }

  p {
    margin-bottom: 0;
  }
`;

export const Text = styled.div`
  ${font('body-md-light')};
  margin-bottom: 52px;
`;
